<template>
  <div class="card">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-4 col-lg-3">
          <div class="flex items-center">
            <img src="@/assets/images/profile-img.png" alt="Profile image" />
            <p>Upload Photo</p>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-4">
          <table class="w-full">
            <tr>
              <td>Name:</td>
              <td>{{ contact.name }}</td>
            </tr>
            <tr>
              <td>Email:</td>
              <td>{{ contact.email }}</td>
            </tr>
          </table>
        </div>
        <div class="col-12 col-md-4 col-lg-4">
          <table class="w-full">
            <tr>
              <td>Date Added:</td>
              <td>{{ contact.createdAt | formatDate }}</td>
            </tr>
            <tr>
              <td>Phone:</td>
              <td>{{ contact.phone }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-4">
          <div class="flex items-start">
            <img
              src="@/assets/images/icons/documents.svg"
              alt="account summary icon"
              class="mr-3"
            />
            <div>
              <div>
                <p class="font-semibold">Account Summary</p>
              </div>
              <div>
                <p class="font-light text-sm">Profile</p>
                <p class="font-bold">{{ contact.profile }}</p>
              </div>
              <div>
                <p class="font-light text-sm">Type</p>
                <p class="font-bold">{{ contact.contactCreatorType.charAt(0).toUpperCase() + contact.contactCreatorType.slice(1)  }}</p>
              </div>
              <div>
                <p class="font-light text-sm">Loyalty Category:</p>
                <p class="font-bold">{{ contact.loyaltyScheme.loyaltyCategory }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <div class="flex items-start">
            <img
              src="@/assets/images/icons/payments.svg"
              alt="transactions icon"
              class="mr-3"
            />
            <div>
              <div>
                <p class="font-semibold">Transaction Highlights</p>
              </div>
              <div>
                <p class="font-light text-sm">Total Shipments:</p>
                <p class="font-bold">0</p>
              </div>
              <div>
                <p class="font-light text-sm">Total Receipts:</p>
                <p class="font-bold">₦00.00</p>
              </div>
              <div>
                <p class="font-light text-sm">Total Account Volume:</p>
                <p class="font-bold">₦00.00</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <div class="flex items-start">
            <img
              src="@/assets/images/icons/person-locked.svg"
              alt="shipments icon"
              class="mr-3"
            />
            <div>
              <div>
                <p class="font-semibold">Active Shipments</p>
                <p class="font-light text-sm">No Active Shipments</p>
              </div>
              <div>
                <p class="font-semibold">Account Management</p>
                <p class="font-light text-sm">Account Manager(s)</p>
                <p class="text-sm font-semibold text-black">
                  {{
                    contact.accountManager[0]
                      ? contact.accountManager[0].name
                      : ""
                  }}
                </p>
                <p
                  class="cursor-pointer text-gold font-semibold text-sm"
                  @click="isAccountManagersModal = true"
                >
                  View Manager(s) 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <account-managers-modal
      :show-modal="isAccountManagersModal"
      @close-modal="isAccountManagersModal = false"
      @show-settings="$emit('show-settings')"
      :contact="contact"
    />
  </div>
</template>

<script>
import AccountManagersModal from "./Modals/AccountManagers";
export default {
  components: {
    AccountManagersModal,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isAccountManagersModal: false,
    };
  },
};
</script>

<style scoped>
td {
  padding: 0.5rem 0;
}
tr td:first-of-type {
  font-weight: bold;
  color: #383f51;
}
p {
  color: #383f51;
  padding-bottom: 0.25rem;
}
.text-gold{
  color: #e3c11a;
}
</style>
